import ProductionIndentDetail from './productionIndentDetail';
import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { get } from '../../../services/apiController';
import { toast, ToastContainer } from 'react-toastify';

const ProductionIndentPrint = () => {
  let params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState();

  const getGrnData = () => {
    try {
      setIsLoading(true);
      get(`/inv/production-indent/?id=${params.id}`)
        .then((res) => {
          setData(res.data.rows[0]);
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log('err', err);
        });
    } catch (error) {
      setIsLoading(false);
      toast.error(error?.response?.data?.data?.rows?.message || 'Something went wrong');
    }
  };

  useEffect(() => {
    getGrnData();
  }, []);

  return (
    <>
      <ToastContainer />
      {isLoading ? <Spinner animation="border" variant="info" /> : <ProductionIndentDetail data={data} isPrint={true} />}
    </>
  );
};

export default ProductionIndentPrint;
